import { render, staticRenderFns } from "./StudyNewPageUnfinishedContent.vue?vue&type=template&id=74854672&scoped=true"
import script from "./StudyNewPageUnfinishedContent.vue?vue&type=script&lang=js"
export * from "./StudyNewPageUnfinishedContent.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageUnfinishedContent.vue?vue&type=style&index=0&id=74854672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74854672",
  null
  
)

export default component.exports